"use strict";

module.exports = function (value) {
	// eslint-disable-next-line no-self-compare
	return value !== value;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/number/is-nan/shim.js
// module id = 958
// module chunks = 0